// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__26SCj","upload":"Small_upload__3HHJN","imageWrap":"Small_imageWrap__Z3dAS","removeBtn":"Small_removeBtn__gQ2tY"};